module.exports = __webpack_public_path__ + "static/1-20866d20089e81298aee9df2ff808a61.png";